import Layout from '@/components/layout/Index';
import BlogHero from '@/components/ui/blog/BlogHero';
import BlogCard from '@/components/ui/blog/BlogCard';
import { useBlogPosts } from '@/hooks/useSanityData';

const Blog = () => {
	const { data: blogPosts } = useBlogPosts();

	// Process each post to format dates
	const formattedPosts =
		blogPosts?.map((post) => ({
			...post,
			published: new Date(post.published).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			}),
		})) || [];

	// Find the featured article (or use the first one if none is marked as featured)
	const featuredArticle =
		formattedPosts.find((post) => post.isFeatured) || formattedPosts[0];

	// Get all non-featured articles
	const regularArticles = formattedPosts
		.filter((post) => post !== featuredArticle)
		.slice(0, 6); // Limit to 6 articles for now

	return (
		<div className='min-h-screen flex flex-col'>
			<Layout>
				<main className='flex-grow pt-24 pb-12'>
					<div className='max-w-7xl mx-auto px-4 md:px-18'>
						{/* Featured Article Section */}
						{featuredArticle && (
							<section className='transition-opacity duration-500'>
								<BlogHero article={featuredArticle} />
							</section>
						)}

						{/* Latest Articles Section */}
						<section className='mt-16'>
							<div className='flex items-center justify-between mb-8'>
								<h2 className='text-2xl font-bold text-gray-900'>
									Latest Articles
								</h2>
								<a
									href='/blog'
									className='text-blog-primary hover:text-blue-700 font-medium text-sm transition-colors duration-200 flex items-center'
								>
									View All Articles
									<svg
										xmlns='http://www.w3.org/2000/svg'
										className='h-4 w-4 ml-1'
										fill='none'
										viewBox='0 0 24 24'
										stroke='currentColor'
									>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth={2}
											d='M9 5l7 7-7 7'
										/>
									</svg>
								</a>
							</div>

							<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8'>
								{regularArticles.map((article, index) => (
									<div
										key={article.id}
										className={`transition-all duration-500 delay-${index * 100}`}
									>
										<BlogCard article={article} />
									</div>
								))}
							</div>
						</section>
					</div>
				</main>
			</Layout>
		</div>
	);
};

export default Blog;
